import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BlogList from './blog/BlogList';
import BlogPost from './blog/BlogPost';
import './blog/Blog.css';

// Sample posts data
const posts = [
  {
    slug: 'first-thoughts',
    title: 'First Thoughts on Building in Public',
    date: '2025-01-16',
    excerpt: 'Reflections on starting a new journey of writing and sharing ideas openly.',
    content: `# First Thoughts on Building in Public

There's something both terrifying and liberating about putting your thoughts out into the world. For the longest time, I kept my ideas locked away in private notebooks, convinced they needed to be perfect before anyone could see them.

But perfection is the enemy of progress.

## Why Start Now?

I've been thinking a lot about the concept of "building in public" lately. Not just sharing the final polished product, but the messy middle — the half-baked ideas, the experiments that fail, the thoughts that evolve over time.

The truth is, **some of my best insights have come from conversations with others**, from sharing an incomplete idea and having someone add their perspective. By keeping everything private, I was cutting myself off from that collaborative discovery process.

## What This Space Is For

This blog isn't about having all the answers. It's about:

- Exploring ideas that fascinate me
- Documenting my learning journey
- Sharing stories and experiences
- Connecting with people who think differently

I want this to be a space where I can write freely, without the pressure of producing perfect content every time. Sometimes it'll be polished essays. Other times it'll be quick observations or half-formed thoughts.

## The Plan Going Forward

I'm committing to writing regularly — not on a strict schedule, but consistently. When something sparks my curiosity or challenges my thinking, I'll write about it.

Topics will probably range all over the place: technology, creativity, philosophy, personal experiences, and whatever else captures my attention. That's the beauty of a personal blog — it can be as eclectic as your interests.

## An Invitation

If you're reading this, thanks for being here. I'd love to hear your thoughts. Whether you agree, disagree, or have a completely different perspective — that's what makes this worthwhile.

Here's to new beginnings and the courage to share imperfect work.

Let's see where this goes.

---

*More posts coming soon. Stay curious.*`
  },
  {
    slug: 'example-post',
    title: 'How to Add Blog Posts',
    date: '2025-01-16',
    excerpt: 'Learn how easy it is to add new blog posts to this site.',
    content: `# How to Add Blog Posts

Adding new blog posts to this site is simple! Just edit the posts array in App.js.

## Post Structure

Each post needs:
- **title**: The post title
- **date**: Publication date
- **slug**: URL-friendly identifier
- **excerpt**: Short description
- **content**: Full markdown content

## Markdown Support

You can use **bold**, *italic*, and [links](https://example.com).

### Code Blocks

\`\`\`javascript
function hello() {
  console.log("Hello, world!");
}
\`\`\`

That's it! Your post will appear on the homepage automatically.`
  },
  {
    slug: 'welcome',
    title: 'Welcome to My Blog',
    date: '2025-01-15',
    excerpt: 'Welcome! This is where I share my thoughts and ideas.',
    content: `# Welcome to My Blog

This is my first blog post. I'll be sharing my thoughts, ideas, and stories here.

Stay tuned for more content!`
  }
];

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BlogList posts={posts} />} />
        <Route path="/post/:slug" element={<BlogPost posts={posts} />} />
      </Routes>
    </Router>
  );
}

export default App;
